import { createFileRoute } from '@tanstack/react-router';

import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// Only the new navigation has this page. Portal users never get the Lumi Agent, whoever `/next` lets in. The page has
// no component: the shell draws the Lumi Agent across the page's room here, the one it shows beside other pages, so a
// chat carries over between the two. ITAR clusters (no third-party services) don't get it at all.
export const Route = createFileRoute('/_authenticated/next/lumi-agent')({
    staticData: {
        access: { permissions: (context) => isInternalUser(context) && window.DISABLE_THIRD_PARTY_TRACKING !== 'true' },
        chrome: 'none',
    } satisfies PageStaticData,
});
